<template>
  <a-card :bordered="false">
    <a-card class="install-ly" title="基本信息" :bordered="false" :headStyle="{borderBottom:'0px'}">
      <div class="switch-box">
        <span>是否显示新人专享</span>
        <a-radio-group class="radio" v-model="enable">
          <a-radio :value="1">
            是
          </a-radio>
          <a-radio :value="0">
            否
          </a-radio>
        </a-radio-group>
      </div>
      <div class="popup-box">
        <div class="popup-title">
          <span>弹窗</span>
          <div class="tooltip">
            <a-tooltip placement="right">
              <template slot="title">
                选中显示分类之后，用户进入该分类弹出新人专享弹窗
              </template>
              <img class="question-icon" src="../../../../assets/question-icon.png" alt="">
            </a-tooltip>
          </div>
        </div>
        <div class="upload-box">
          <div class="upload-box-left">
            <a-upload
              :disabled="enable==0"
              name="avatar"
              list-type="picture-card"
              class="avatar-uploader"
              :show-upload-list="false"
              :action="uploadFileUrl"
              :before-upload="beforeUpload"
              @change="handleChange"
            >
              <img v-if="popupImage" :src="popupImage" class="selected-image" alt="avatar"/>
              <div v-else>
                <a-icon :type="loading ? 'loading' : 'plus'"/>
              </div>
            </a-upload>
            <div class="upload-text">
              温馨提示：图片建议上传尺寸为640px*436px，格式.jpg、.png、jpeg、gif
            </div>
          </div>
          <div class="upload-box-right">
            <a-checkbox-group v-model="popupPostion" :disabled="enable==0">
              <a-checkbox value="1">
                首页
              </a-checkbox>
              <a-checkbox value="3">
                商品详情
              </a-checkbox>
            </a-checkbox-group>
          </div>
        </div>
      </div>
      <div class="popup-box">
        <div class="popup-title">
          <span>底部弹窗</span>
          <a-tooltip placement="right">
            <template slot="title">
              如果弹窗和底部弹窗都选择，首先弹出弹窗，弹窗关闭之后再显示底部弹窗
            </template>
            <img class="question-icon" src="../../../../assets/question-icon.png" alt="">
          </a-tooltip>
        </div>
        <div class="upload-box">
          <div class="upload-box-left">
            <a-input :disabled="enable==0" :maxLength="8" v-model="bottomPopupTitle" style="width: 440px;"></a-input>
          </div>
          <div class="upload-box-right">
            <a-checkbox-group v-model="bottomPopupPostion" :disabled="enable==0">
              <a-checkbox value="1">
                首页
              </a-checkbox>
            </a-checkbox-group>
          </div>
        </div>
      </div>
      <div class="popup-box">
        <div class="popup-title">
          <span>新人专享专区</span>
          <a-tooltip placement="right">
            <template slot="title">
              选中显示分类之后，用户进入该分类以固定区域矩形横幅展示新人专享
            </template>
            <img class="question-icon" src="../../../../assets/question-icon.png" alt="">
          </a-tooltip>
        </div>
        <div class="upload-box">
          <div class="upload-box-left">
            <a-input :disabled="enable==0" :maxLength="8" v-model="userShareTitle" style="width: 440px;"></a-input>
          </div>
          <div class="upload-box-right">
            <a-checkbox-group v-model="userSharePostion" :disabled="enable==0">
              <a-checkbox value="1">
                首页
              </a-checkbox>
              <a-checkbox value="3">
                商品详情
              </a-checkbox>
            </a-checkbox-group>
          </div>
        </div>
      </div>
    </a-card>
    <a-card class="install-ly" title="活动规则" :bordered="false" :headStyle="{borderBottom:'0px'}">
      <a-textarea
        :disabled="enable==0"
        :style="input_style"
        v-model="ruleContent"
        style="width: 600px;margin-left: 80px;"
        :maxLength="1000"
        :auto-size="{ minRows: 3, maxRows: 5 }"
      />
    </a-card>
    <div class="bottom-button">
      <a-button @click="onCancel">取消</a-button>
      <a-button style="margin-left: 50px" type="primary" @click="onSave">保存</a-button>
    </div>
  </a-card>
</template>

<script>
import { USER_SHARE_ID } from '@/store/mutation-types'

export default {
  name: 'BasicSetting',
  data() {
    return {
      input_style: { 'max-width': '600px' },
      enable: 1,
      loading: false,
      popupImage: '',
      popupPostion: [],
      bottomPopupTitle: '新人大礼包',
      bottomPopupPostion: [],
      userSharePostion: [],
      userShareTitle: '新人大礼包',
      ruleContent: '',
      uploadFileUrl: this.getUploadFileUrl(),
      text: '',
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      id: '',
      status: false
    }
  },
  created() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'BasicSetting', title: '基础设置' },
      { name: 'BindCoupon', title: '优惠券关联' }
    ])
  },
  mounted() {
    this.getSettingDetail()
  },
  methods: {
    getSettingDetail() {
      this.getHttpServices().getServerApiService().post('newUserShare/getNewUserShareSet/' + this.merchantId + '/' + this.platformId)
        .then(res => {
          this.getLogUtils().logWithTag('getSettingDetail', res)
          if (res) {
            this.bottomPopupPostion = res.bottomPopupPostion ? res.bottomPopupPostion.split(',') : [],
              this.bottomPopupTitle = res.bottomPopupTitle,
              this.enable = res.enable,
              this.popupImage = res.popupImage,
              this.popupPostion = res.popupPostion ? res.popupPostion.split(',') : [],
              this.ruleContent = res.ruleContent ? res.ruleContent : '',
              this.userShareId = res.userShareId,
              this.userSharePostion = res.userSharePostion ? res.userSharePostion.split(',') : [],
              this.userShareTitle = res.userShareTitle
            this.$ls.set(USER_SHARE_ID, res.userShareId, 7 * 24 * 60 * 60 * 1000)
            this.getLogUtils().logWithTag('新人专享ID', this.$ls.get(USER_SHARE_ID))
          }
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    checkForm() {
      if (this.bottomPopupPostion && this.bottomPopupPostion.length > 0 && !this.bottomPopupTitle) {
        this.$message.error('请输入底部弹窗标题')
        return false
      }
      if (this.userSharePostion && this.userSharePostion.length > 0 && !this.userShareTitle) {
        this.$message.error('请输入新人专享专区标题')
        return false
      }
      if (!this.ruleContent) {
        this.$message.error('请输入活动规则')
        return false
      }
      return true
    },
    onSave() {
      if (this.checkForm()) {
        this.getHttpServices().getServerApiService().post('newUserShare/save', ({
          merchantId: this.merchantId,
          platformId: this.platformId,
          bottomPopupPostion: this.bottomPopupPostion.join(','),
          bottomPopupTitle: this.bottomPopupTitle,
          enable: this.enable,
          popupImage: this.popupImage ? this.popupImage : 'https://imgb.woyoubooking.com/common/gift-coupon-bg.png',
          popupPostion: this.popupPostion.join(','),
          ruleContent: this.ruleContent,
          userShareId: this.userShareId,
          userSharePostion: this.userSharePostion.join(','),
          userShareTitle: this.userShareTitle
        })).then(res => {
          this.$message.success('保存成功')
          this.getLogUtils().logWithTag('onSave', res)
          this.$ls.set(USER_SHARE_ID, res, 7 * 24 * 60 * 60 * 1000)
          this.getLogUtils().logWithTag('新人专享ID', this.$ls.get(USER_SHARE_ID))
        }).catch(reason => this.showNetWorkErrorMessage(reason))
      }
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.loading = true
        return
      }
      if (info.file.status === 'done') {
        this.popupImage = info.file.response.data
        this.loading = false
        this.getLogUtils().logWithTag('this.popupImage', this.popupImage)
      }
    },
    onCancel() {
      this.getSettingDetail()
    },
    getUploadFileUrl() {
      let appConfig = this.getAppConfig()
      return appConfig.baseUrl + (appConfig.isDev ? '/' : '') + 'base/upload'
    },
    beforeUpload(file) {
      // 限制图片 格式、size、分辨率
      const isJPG = file.type === 'image/jpeg'
      const isJPEG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isGIF = file.type === 'image/gif'
      if (!(isJPG || isJPEG || isPNG || isGIF)) {
        this.$message.error('上传图片的格式不正确，不是JPG、JPEG、GIF、PNG')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 1
      if (!isLt2M) {
        this.$message.error('上传的文件不能大于1M!')
        return false
      }
      return true
    }
  }
}
</script>

<style lang="less">
@import url('../../../CustomPage.less');

body {
  .ant-tooltip-inner {
    width: 480px !important;
  }
}

.switch-box {
  margin-left: 80px;
  margin-bottom: 40px;
}

.radio {
  margin-left: 20px;
}

.popup-box {
  margin-bottom: 20px;

  .popup-title {
    margin-left: 80px;
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    .question-icon {
      margin-left: 5px;
      width: 15px;
      height: 15px;
    }
  }
}

.upload-box {
  margin-left: 80px;
  display: flex;
  align-items: center;

  .upload-box-left {
    width: 600px;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .upload-text {
      width: 350px;
      margin-left: 20px;
    }
  }

  .upload-box-right {
  }
}

.selected-image {
  width: 79px;
  height: 65px;
}

.avatar-uploader > .ant-upload {
  width: 79px;
  height: 65px;
}

.ant-upload-picture-card-wrapper {
  width: 79px;
}

.ant-upload-select-picture-card i {
  font-size: 22px;
  color: #999;
}

.bottom-button {
  margin-left: 300px;
}
</style>